import "../stylesheets/productContainer.scss";

// TYPES

import { ReactNode } from "react"

type ProductContainerProps = {
    children: ReactNode[];
}

// COMPONENTS

function ProductContainer({children} : ProductContainerProps) {
    return (
        <div className="product-container">
            {children.map((child) => (
                child
            ))}

        </div>
    )

}

export default ProductContainer